module.exports = __webpack_public_path__ + "media/images/subarena-93ee7afddf507813f7812cf3f51355b5.png";